import { CurrencyDollarIcon } from '@heroicons/react/24/outline';

import { PaySurgeBadge } from '../api/types';

type Props = {
  surge?: PaySurgeBadge | null;
  /** The panel tag spells out what the number is; the card has no room to. */
  variant?: 'card' | 'tag';
};

const formatAmount = (cents: number) => `+$${(cents / 100).toFixed(2)}`;

/**
 * Surge pay on a shift (GRAVY-10443): "+$1.55" while applied, "Surge paused"
 * in its place while paused (Figma 38620:7269, 40593:196212; Aly chose
 * "Surge paused" over a bare "Paused" for decision 34). Nothing otherwise.
 */
const SurgeBadge = ({ surge, variant = 'card' }: Props) => {
  if (!surge) return null;

  const paused = surge.status === 'paused';
  const text = paused
    ? variant === 'tag'
      ? 'Surge pay paused'
      : 'Surge paused'
    : variant === 'tag'
      ? `Surge pay ${formatAmount(surge.applied_cents)}/hr`
      : formatAmount(surge.applied_cents);

  return (
    <span
      className={`dashv2-surge is-${variant}${paused ? ' is-paused' : ''}`}
      data-testid="surgeBadge"
      aria-label={
        paused
          ? 'Surge pay paused'
          : `Surge pay ${formatAmount(surge.applied_cents)} per hour`
      }
    >
      <CurrencyDollarIcon aria-hidden="true" />
      {text}
    </span>
  );
};

export default SurgeBadge;
